import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description =
  '5G関連サービス「ドコモオープンイノーべションクラウド」を開発いたしました。このサービスは、5Gを活用したサービス開発者向けのものです。弊社はプロジェクト支援、サービス設計、クラウドをフル活用したサーバーレスアーキテクチャでのウェブシステムの開発を実施しました。'

const ogpImg = 'https://aitria.co.jp/images/img/cases/ntt/ogp_ntt.png'

export const nttPageMeta: PageMeta = {
  title: 'docomo Open Inovation Cloud | 事例 | Aitria（アイトリア）',
  description,
  keyword: 'UX/UI フロントエンド開発 ヒューリスティック調査 情報設計 ',
  image: ogpImg,
  url: `${SITE_URL}/cases/ntt/`,
}

export const nttSchema = buildCaseStudySchema({
  slug: 'ntt',
  pageTitle: nttPageMeta.title,
  description: nttPageMeta.description,
  headline: 'docomo Open Inovation Cloud',
  alternativeHeadline: '株式会社NTTドコモ',
  primaryImage: ogpImg,
  images: [ogpImg, 'https://aitria.co.jp/images/img/cases/caseStudyTop/ntt.webp'],
  clientName: '株式会社NTTドコモ',
  breadcrumbLabel: 'docomo Open Inovation Cloud',
})
